import SockJS from 'sockjs-client';
import { usesCrmChatSameOriginProxy } from '@/config/chat-ws';
import { getAccessToken } from '@/shared/auth/jwt-storage';
export function readBearerAuthHeaders() {
    const token = getAccessToken();
    if (!token)
        return {};
    return { Authorization: `Bearer ${token}` };
}
export function readStompConnectHeaders() {
    return readBearerAuthHeaders();
}
/**
 * SockJS handshake cannot rely on STOMP CONNECT headers alone — backend also accepts
 * `?access_token=<jwt>`. Webpack/nginx proxy rewrites that query to `Authorization: Bearer`.
 */
export function buildSockJsUrl(baseUrl) {
    const token = getAccessToken();
    if (!token)
        return baseUrl;
    try {
        const u = new URL(baseUrl, window.location.origin);
        u.searchParams.set('access_token', token);
        return usesCrmChatSameOriginProxy()
            ? `${u.pathname}${u.search}`
            : u.toString();
    }
    catch {
        const sep = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${sep}access_token=${encodeURIComponent(token)}`;
    }
}
export function buildSockJsClientOptions() {
    const headers = readBearerAuthHeaders();
    const withHeaders = Object.keys(headers).length > 0 ? { headers } : {};
    return {
        transports: ['websocket', 'xhr-streaming', 'xhr-polling'],
        transportOptions: {
            'xhr-streaming': withHeaders,
            'xhr-polling': withHeaders,
        },
    };
}
export function createCrmSockJsWebSocket(sockJsUrl) {
    return new SockJS(buildSockJsUrl(sockJsUrl), undefined, buildSockJsClientOptions());
}
